var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplaneTilt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AirplaneTilt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3672 6.38025L13.7422 8.849L16.2422 15.724L14.3672 17.599L10.6328 12.1303L8.74219 13.849V15.724L6.86719 17.599L5.75781 14.3256L2.49219 13.224L4.36719 11.349H6.24219L8.11719 9.474L2.49219 5.724L4.36719 3.849L11.2422 6.349L13.7188 3.73181L13.6641 3.77088C14.0163 3.41864 14.494 3.22075 14.9922 3.22075C15.4903 3.22075 15.9681 3.41864 16.3203 3.77088C16.6726 4.12312 16.8704 4.60086 16.8704 5.099C16.8704 5.59714 16.6726 6.07489 16.3203 6.42713L16.3672 6.38025Z",
    stroke: "url(#paint0_linear_7937_33980)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7937_33980",
    x1: 13.8205,
    y1: 16.5097,
    x2: 4.56179,
    y2: 3.22075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneTilt);
export default __webpack_public_path__ + "static/media/AirplaneTilt.6394ede80a9949415bec6fc37ee92b7d.svg";
export { ForwardRef as ReactComponent };